import { Component, input, InputSignal } from '@angular/core';

/** One "for eg." city row in the location sheet. The message is projected so its i18n stays put. */
@Component({
  selector: 'app-location-example-card',
  templateUrl: './location-example-card.component.html',
})
export class LocationExampleCardComponent {
  iconSrc: InputSignal<string> = input.required<string>();
}
